import { createAsionInstance } from "../../../interceptors/axios/axios-instance";
import { API_TIMEOUT, BaseApi as localBase } from "../../../interceptors/base-axios/base-axios"


const glueBaseDownlaod = createAsionInstance({
    baseURL: "https://dss-osm-glue-service-srpnsnea-qa.apps.dev.aks.forgeapp.honeywell.com",
    timeout: API_TIMEOUT,
});

const damServiceBaseDownlaod = createAsionInstance({
    baseURL: "https://dads.apiservices.honeywell.com/dam-service",
    timeout: API_TIMEOUT,
});

export const BaseApi = { ...localBase, glueBaseDownlaod,damServiceBaseDownlaod }